import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Session from '../services/session';
import Navbar from '../components/navbar';
import OfflineBanner from '../components/offline-banner';
import MobileDock from '../components/mobile-dock';
import NotificationsContainer from 'favoris-web/components/notifications/container.gts';
import ModalsContainer from 'favoris-web/components/modals/container.gts';
import LightboxContainer from 'favoris-web/components/lightbox/container.gts';

interface ApplicationSignature {
  Args: {};
}

class ApplicationTemplate extends Component<ApplicationSignature> {
  @service declare router: RouterService;
  @service declare session: Session;

  get isLoginRoute(): boolean {
    return this.router.currentRouteName === 'login';
  }

  get isShareRoute(): boolean {
    return this.router.currentRouteName === 'share';
  }

  get showChrome(): boolean {
    return this.session.isAuthenticated && !this.isLoginRoute;
  }

  <template>
    {{pageTitle "Saive"}}

    {{#if this.isShareRoute}}
      {{! Share drawer: bare outlet only — no chrome, no bg, no container.
          The share template is a full-viewport overlay over the transparent window. }}
      {{outlet}}
    {{else}}
      <div class="bg-base-200 min-h-screen">
        {{#if this.showChrome}}
          <Navbar />
          <OfflineBanner />
        {{/if}}

        <div class="container mx-auto px-4 py-8 pb-24 lg:pb-8">
          {{outlet}}
        </div>

        {{#if this.showChrome}}
          <MobileDock />
        {{/if}}
      </div>
      {{! Global notifications container }}
      <NotificationsContainer />

      {{! Global modals container }}
      <ModalsContainer />

      {{! Global lightbox container }}
      <LightboxContainer />
    {{/if}}
  </template>
}

export default ApplicationTemplate;
